'use client';

import { Icon } from '@/general/Icons/Icon';
import clsx from 'clsx';
import Link from 'next/link';
import { FC, ReactNode } from 'react';
import { shallow } from 'zustand/shallow';

import { modalStore } from '@/stores/modalStore';

import { ButtonIcon } from '../../Button/ButtonIcon';
import { HeaderMenuMobileMenu } from '../../HeaderMenuMobile/HeaderMenuMobileMenu';
import { Shade } from '../../Shade/Shade';
import { InvestorHeaderMenuData, InvestorHeaderMenuItem } from '../InvestorHeaderMenu.type';
import { InvestorHeaderMenuLogoLink } from '../InvestorHeaderMenuLogo';

type Props = {
  investorHeaderData: InvestorHeaderMenuData;
};

export const InvestorHeaderMenuMobileContent: FC<Props> = ({ investorHeaderData }) => {
  const { closeModal } = modalStore(
    (state) => ({ closeModal: state.closeModal, activeModal: state.activeModal }),
    shallow,
  );

  return (
    <HeaderMenuMobileMenu
      headerBar={
        <div className="flex h-full w-full items-center justify-between">
          <InvestorHeaderMenuLogoLink href="/investors" />
          <ButtonIcon
            icon={<Icon name="close" />}
            title="Close"
            styling="round"
            variant="tertiary"
            size="small"
            onClick={() => closeModal('mobileMenu')}
          />
        </div>
      }
    >
      <ul className="-mx-3 flex flex-col gap-1">
        {investorHeaderData.navigation.map((item) => (
          <MenuLink key={item.label} label={item.label} item={item} />
        ))}
      </ul>
    </HeaderMenuMobileMenu>
  );
};

const linkClasses = clsx(
  'c-shade_container c-shade_container--grey relative flex w-full cursor-pointer items-center justify-between overflow-hidden rounded-xs px-4 py-3 text-left no-underline',
);

const MenuLink: FC<{
  label: ReactNode;
  item: InvestorHeaderMenuItem;
}> = ({ label, item }) => {
  return (
    <li>
      <Link href={item.href} className={linkClasses}>
        <Shade noBackground />
        <span>{label}</span>
      </Link>
    </li>
  );
};
